export default class Search {
    constructor({root}) {
        this.root = root
        this.controller = null
        this.container = root.querySelector('[data-container]')
        this.showBtn = root.querySelector('[data-open]')
        this.hideBtn = root.querySelector('[data-hide]')
        this.clearBtn = root.querySelector('[data-clear]')
        this.inp = root.querySelector('input')
        this.results = root.querySelector('[data-results]')
        this.form = root.querySelector('form')
    }

    init() {
        if (this.showBtn) {
            this.showBtn.addEventListener('click', event => {
                event.preventDefault()
                this.show()
            })
        }
        if (this.hideBtn) {
            this.hideBtn.addEventListener('click', event => {
                event.preventDefault()
                this.hide()
            })
            document.addEventListener('click', e => {
                if (!!e.target.closest('[data-open]')) {
                    return
                }
                if (!e.target.closest('[data-container]') && this.container.classList.contains('active')) {
                    this.hide()
                }
            })
        }
        if (this.clearBtn) {
            this.clearBtn.addEventListener('click', event => {
                event.preventDefault()
                this.clear()
            })
        }
        let callback = this.e(() => {
            this._search()
        })
        this.form.addEventListener("input", event => {
            if (this.inp.value === '') {
                if (this.clearBtn) {
                    this.clearBtn.style.display = 'none'
                }
                this.results.innerHTML = ''
            } else {
                if (this.clearBtn) {
                    this.clearBtn.style.display = ''
                }
            }
            callback()
        })
    }

    show() {
        this.showBtn.classList.add('opacity-0')
        this.showBtn.classList.add('invisible')
        this.container.classList.add('active')
        this.container.classList.remove('invisible')
        this.container.classList.remove('opacity-0')
        this.inp.focus()
    }

    hide() {
        this.container.classList.remove('active')
        this.container.classList.add('opacity-0')
        this.container.classList.add('invisible')
        this.showBtn.classList.remove('invisible')
        this.showBtn.classList.remove('opacity-0')
        if (!!this.controller) {
            this.controller.abort()
        }
        this.inp.value = ''
        this.results.innerHTML = ''
    }

    e(e, t = 400) {
        let i;
        return (...o) => {
            clearTimeout(i)
            i = setTimeout((() => {
                e.apply(this, o)
            }), t)
        }
    }

    async _search() {
        if (!!this.controller) {
            this.controller.abort()
        }
        if (this.inp.value === '') {
            this.results.innerHTML = ''
            return;
        }
        this.controller = new AbortController();
        let formData = new FormData()
        formData.append('action', 'ad_courses_search_ajax')
        formData.append('search', this.inp.value)
        try {
            let response = await fetch(themeOptions.ajax_url, {
                method: 'POST',
                body: formData,
                signal: this.controller.signal
            })
            let {result} = await response.json()
            this.results.innerHTML = ''
            if (result.length) {
                this.sResult(result).forEach(e => {
                    this.results.appendChild(e)
                })
            } else {
                this.results.innerHTML = '<div class="p-2">По запросу ничего не найдено</div>'
            }

        } catch (err) {
            if (err.name !== 'AbortError') {
                this.results.innerHTML = '<div class="p-2">Произошла ошибка. проверьте интернет соединение или повторите позже</div>'
            }
        }
    }

    sResult(results) {
        function el({url, name}) {
            let a = document.createElement('a')
            a.classList.add('block')
            a.classList.add('p-2')
            a.classList.add('hover:bg-bl700')
            a.href = url
            a.target = '_blank'
            a.textContent = name
            return a
        }

        return results.map(item => el(item))
    }

    clear() {
        this.inp.value = ''
        this.clearBtn.style.display = 'none'
        this.inp.dispatchEvent(new Event('input', {bubbles: true}))
        this.inp.focus()
    }
}